<template>
  <f7-page :name="name" :id="name" v-bind:class="{
    'has-fab': has_fab,
    'private-gym-page': true
  }"
     @page:init="$emit('init')"
  >
    <page-top-navbar v-if="navbar"></page-top-navbar>

<!--    <div class="container">-->
      <slot></slot>
<!--    </div>-->
  </f7-page>
</template>

<script>

import PageTopNavbar from "../../components/nav/PageTopNavbar.vue";

export default {
  components: {
    PageTopNavbar,
  },

  props: {
    'name': {required: true},
    'navbar': {default: true},
    'has_fab': {default: false},
  },

  mixins: [],

  data: function () {
    return {
      title: 'Title',
    };
  },

  computed: {
    //
  },

  created() {
    //
  },

  mounted() {
    //
  },

  methods: {
    //
  },

  watch: {
    //
  }
};
</script>
